import { Volume2 } from "lucide-react";
import { PixelSkeetScene } from "./PixelSkeetScene";

function Highlight({ children }: { children: React.ReactNode }) {
  return (
    <span className="rounded-[4px] bg-[#C6A971]/25 px-1.5 py-0.5 text-[#2A1510] decoration-[#C6A971] underline-offset-4">
      {children}
    </span>
  );
}

export function SportingLifeSection() {
  return (
    <section className="relative overflow-hidden bg-[#F5EFE2] py-20 md:py-32">
      <PixelSkeetScene />
      <div className="relative z-10 mx-auto max-w-[860px] px-6">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:justify-center sm:gap-5">

          <span
            aria-hidden="true"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-[#2A1510]/20 bg-[#FDFAF3] text-[#8B6F47]"
          >
            <Volume2 size={20} strokeWidth={2.2} />
          </span>
          <h2 className="font-heading text-4xl font-extrabold uppercase leading-[1.05] text-[#2A1510] sm:text-5xl md:text-6xl">
            The Sporting Life
          </h2>
        </div>

        <p className="mt-3 text-center font-ui text-sm font-medium normal-case text-[#8B6F47]">
          /ˈspȯr-tiŋ līf/ &nbsp;·&nbsp; noun
        </p>

        <p className="mx-auto mt-8 max-w-[760px] font-body text-[17px] leading-[1.7] text-[#2A1510] md:text-[18px]">
          The Sporting Life is what happens when you refuse to sit on the sidelines. It's{" "}
          <Highlight>the grit of competing</Highlight> — on the field, on the course, in the woods, on the
          water — and the fun that comes from <Highlight>chasing your best</Highlight>, win or lose. It's
          golfing, hunting, fishing, hiking, riding, running, playing the game you love, or riding every play
          with the team you're loyal to. <Highlight>It's earned.</Highlight> Not by luck, but by consistently
          showing up, working hard, and doing it again tomorrow.
        </p>

        <p className="mt-10 text-center font-ui text-xs font-extrabold uppercase text-[#FA5021] md:text-sm">
          Compete. Chase It. Earn It.
        </p>
      </div>
    </section>
  );
}
